module.exports = __webpack_public_path__ + "img/lead-13e.30eb6ebc.png";